import { render, staticRenderFns } from "./record.vue?vue&type=template&id=f8fb4356&scoped=true"
import script from "./record.vue?vue&type=script&lang=js"
export * from "./record.vue?vue&type=script&lang=js"
import style0 from "./record.vue?vue&type=style&index=0&id=f8fb4356&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8fb4356",
  null
  
)

export default component.exports